import eventBus from '../../plugins/eventBus'
import api from '@/plugins/api'
import { generalSuccess, generalError, addToFavoritesError, addToFavoritesSuccess } from '@/plugins/popups'
import Model from 'scomponent/src/data/model'
import fieldTranslation from '../../../.env.models.json'
import { UserModel } from './UserModel'

export class ItemModel extends Model {
  private static instance: ItemModel = new ItemModel()
  id: number = 0
  name: string = ''
  description: string = ''
  image: string = ''
  salePrice: number = 0
  oldPrice: number = 0
  totalQuantity: number = 0
  rating: number = 0
  usage: string = ''
  specifications: Object[] = []
  properties: Object[] = []
  outOfStock: boolean
  isFavorite: boolean = false

  constructor() {
    super()
    this.setTranslateField(fieldTranslation['Product'])
  }

  public static getInstance(): ItemModel {
    this.instance.setTranslateField(fieldTranslation['Product'])
    return ItemModel.instance
  }

  setTotalQuantity(totalQuantity: number) {
    this.totalQuantity = totalQuantity
    return this
  }

  addToFavorites(successCallback?: any, errorCallback?: any) {
    if (!successCallback) {
      successCallback = () => {}
    }
    if (!errorCallback) {
      errorCallback = () => {}
    }

    const payload = {
      products: [{ id: this.id }],
    }
    api()
      .put(`/me/favorite/products`, payload)
      .then((response) => {
        if (!(response.data.status === 0)) {
          errorCallback()
          generalError()
          return
        }
        successCallback()
        addToFavoritesSuccess()
        this.isFavorite = true
      })
      .catch((error) => {
        if (error.response.status === 401) {
          addToFavoritesError()
          if (!UserModel.getInstance().isLogged()) {
            eventBus.$emit('user:start-login')
          }
          return
        }
        errorCallback()
        generalError()
      })
  }

  deleteFavorite(successCallback?: any, errorCallback?: any) {
    if (!successCallback) {
      successCallback = () => {}
    }
    if (!errorCallback) {
      errorCallback = () => {}
    }

    const payload = {
      products: [{ id: this.id }],
    }
    api()
      .delete(`/me/favorite/products`, { data: payload })
      .then((response) => {
        if (!(response.data.status === 0)) {
          errorCallback()
          generalError()
          return
        }
        eventBus.$emit('item:deleted-favorite')
        successCallback()
        generalSuccess()
      })
      .catch(() => {
        errorCallback()
        generalError()
      })
  }
}
